import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        name: 'quiz-dashboard',
        path: '/quiz-dashboard',
        component: () => import('@/pages/quiz-dashboard/QuizDashboard.vue'),
        props: true,
        meta: {
            title: 'Quiz Dashboard',
            middleware: [GateKeeperMiddleware],
            ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view quiz dashboard'),
        },
    },
];
